import { Link } from "react-router-dom";

export function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="brand-block">
          <div className="b">
            V<em>oy</em>
          </div>
          <p>The OTA killer. Zero-markup travel, built on transparency and a flat membership.</p>
        </div>
        <div className="col">
          <h5>Product</h5>
          <Link to="/">AI Search</Link>
          <Link to="/companion">Companion</Link>
          <Link to="/games">Gaming</Link>
          <Link to="/subscription">Pricing</Link>
        </div>
        <div className="col">
          <h5>Company</h5>
          <a href="#">The Moat</a>
          <a href="#">Manifesto</a>
          <a href="#">Careers</a>
          <a href="#">Press</a>
        </div>
        <div className="col">
          <h5>Legal</h5>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <a href="#">Refund policy</a>
          <a href="#">Contact</a>
        </div>
      </footer>
      <div className="footer-base">
        <span>© 2026 Voy Earth · The OTA killer</span>
        <span className="footer-ticker">
          <span className="footer-ticker-dot" aria-hidden="true">●</span>
          Live · Supplier prices
        </span>
        <span>
          Built for{" "}
          <span style={{ color: "var(--v6-accent)", fontFamily: "var(--v6-font-serif)", fontStyle: "italic" }}>
            travelers
          </span>
        </span>
      </div>
    </>
  );
}
